export default __webpack_public_path__ + "static/media/SPOT.6e0258c8.png";